import { connect } from 'react-redux'
import {
  Eye, Search, Settings, Chat
} from 'assets/icons/components'
import { setIsFullScreen, setMainContent, setMainContentMobile, setActiveConversation } from 'actions'
import { useTranslation } from 'react-i18next'
import i18n from 'config/i18n'
import {
  Unread
} from './style'

const MainContent = (props) => {
  const { t } = useTranslation('live', { i18n })
  const { contentKeyMobile, dispatch, unread } = props
  const content = [
    {
      browserkey: 'dashboard',
      mobileKey: 'history-mobile',
      label: t('History'),
      icon: <Eye className='icon__icon icon__icon--history' />
    },
    {
      browserkey: 'dashboard',
      mobileKey: 'dashboard',
      label: t('Video chat'),
      icon: <Search className='icon__icon icon__icon--search' />
    },
    {
      browserkey: 'dashboard',
      mobileKey: 'message-mobile',
      label: t('Message'),
      icon: <Chat className='icon__icon icon__icon--message' />
    },
    {
      browserkey: 'dashboard',
      mobileKey: 'settings-mobile',
      label: t('Settings'),
      icon: <Settings className='icon__icon icon__icon--settings' />
    }
  ]

  const setContent = (browserkey, mobileKey) => {
    dispatch(setMainContent(browserkey))
    dispatch(setMainContentMobile(mobileKey))
    dispatch(setIsFullScreen(false))
    dispatch(setActiveConversation(null))
  }

  return (
    <div className='live-container__bottom-navbar'>
      {content.map(item => (
        <div
          className={`bottom-navbar__item-wrapper ${contentKeyMobile === item.mobileKey ? 'bottom-navbar__item-wrapper--active' : ''}`}
          key={item.mobileKey}
          onClick={() => setContent(item.browserkey, item.mobileKey)}>
          <div className='item-wrapper__icon'>
            {item.icon}
          </div>
          <div className='item-wrapper__label'>
            {item.label}
          </div>
          { item.mobileKey === 'message-mobile' && unread > 0 ? <Unread>{ unread }</Unread> : '' }
          <div className='item-wrapper__active-bar'></div>
        </div>
      ))}
    </div>
  )
}

const mapStateToProps = (state) => ({
  contentKey: state.mainContentReducer.contentKey,
  contentKeyMobile: state.mainContentReducer.contentKeyMobile,
  unread: state.chatReducer.unread,
})

export default connect(mapStateToProps)(MainContent)
